import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getImagesFromImagesVm } from './shared';
import { getSummaryCardStyles } from './style';

const MaxThumbnails = 5;

export const ImageListSummaryCardDetails = (props) => {
  const {
    images, isLogos, i18n, isPortrait, videos, isVideos,
  } = props;

  const imageList = getImagesFromImagesVm(images);

  let noDataString;
  if (isLogos) {
    noDataString = _TL_('No logos');
  } else if (isVideos) {
    noDataString = _TL_('No videos');
  } else {
    noDataString = _TL_('No images');
  }

  const thumbnails = _.reduce(
    imageList,
    (memo, image) => {
      const firstImg = _.first(image);

      if (isPortrait && firstImg.isPortrait) {
        return firstImg.isPortrait === isPortrait ? [...memo, firstImg.ThumbnailUrl] : [...memo];
      }
      return firstImg.isLogo === isLogos ? [...memo, firstImg.ThumbnailUrl] : [...memo];
    },
    []
  );

  const videoThumbnails = videos.map(video => video.thumbnailUrl);
  const allThumbnails = [...thumbnails, ...videoThumbnails];

  const moreMediaCount = allThumbnails.length - MaxThumbnails;
  const thumbnailsToDisplay = allThumbnails.slice(0, MaxThumbnails);

  const classes = useDefaultStyles(getSummaryCardStyles);

  return (
    <div className={classNames('image-list-card-details-container', classes.ImageListCardDetailsContainer)}>
      {thumbnailsToDisplay.map(url => (<img src={url} alt="" />))}
      {moreMediaCount > 0 && (<span className="summary-card-more-text">{i18n.getString(_TL_('+{{count}} more'), { count: moreMediaCount })}</span>)}
      {allThumbnails.length === 0 && (<span className="summary-card-empty-text">{i18n.getString(noDataString)}</span>)}
    </div>
  );
};

ImageListSummaryCardDetails.propTypes = {
  images: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  isLogos: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isPortrait: PropTypes.bool,
  isVideos: PropTypes.bool,
  videos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    idString: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
  })),
};

ImageListSummaryCardDetails.defaultProps = {
  isPortrait: false,
  isVideos: false,
  videos: [],
};
